
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import CourseCard from './CourseCard.vue'
import type { CourseItem } from '@xt/client/utils/activities/types'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    CourseCard
  }
})
export default class Courses extends Vue {
  @Prop({ default: () => [] }) readonly courses!: Array<CourseItem>

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
